import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDefaultRegistry } from 'react-jsonschema-form/lib/utils';
import { Accordion, Button, Card } from 'react-bootstrap';
import styles from '../AccordionField.scss';

const AccordionField = (props) => {
  const [collapse, setCollapse] = useState(false);
  const registry = getDefaultRegistry();
  const { uiSchema, errorSchema, idSchema, name, required, disabled, readonly, schema, formData, autofocus, onBlur } = props;

  const { t } = useTranslation();

  const handleToggle = () => {
    setOpen(!open);
    toggleAccordion();
  };

  const toggleAccordion = () => {
    setCollapse(!collapse);
  };

  const { SchemaField } = registry.fields;
  let content = uiSchema.content.map((item, index) => {
    return (
      <SchemaField
        key={index}
        name={name}
        required={required}
        schema={schema}
        uiSchema={item}
        errorSchema={errorSchema}
        idSchema={idSchema}
        formData={formData}
        onChange={props.onChange}
        registry={registry}
        disabled={disabled}
        readonly={readonly}
        autofocus={autofocus}
        onBlur={onBlur}
      />
    );
  }, this);

  return (
    <Accordion defaultActiveKey={uiSchema.title} flush>
      <Card className={styles.accordion}>
        <Accordion.Header>
          <Button
            variant="link"
            onClick={handleToggle}
            aria-controls={uiSchema.title}
            aria-expanded={open}
            className={open ? styles.collapse : ''}
          >
            <span className={styles.title}>{t(uiSchema.title)}</span>
            <span className={styles.toggleIcon}>
            {open ? (
                <>
                  {t('Action.Hide')} <span className="bi bi-chevron-up"></span>
                </>
              ) : (
                <>
                  {t('Action.Show')} <span className="bi bi-chevron-down"></span>
                </>
              )}
            </span>
          </Button>
        </Accordion.Header>
        <Accordion.Body id={uiSchema.title} className={open ? 'show' : 'collapse'}>
          <div className={styles.cardBody}>{content}</div>
        </Accordion.Body>
      </Card>
    </Accordion>
  );
};

export default AccordionField;
